// 左侧导航
const navLinks = [
	{
		name: '商户管理',
		route: '/business',
		routeName: 'business',
		icon: 'nav-business'
	},
	{
		name: '应用管理',
		route: '/app',
		routeName: 'app',
		icon: 'nav-app'
	},
	{
		name: '外呼线路管理',
		route: '/calloutLine',
		routeName: 'calloutLine',
		icon: 'nav-app'
	},
	{
		name: '会话存档申请',
		route: '/msgauditApply',
		routeName: 'msgauditApply',
		icon: 'nav-audit'
	},
	{
		name: '菜单管理',
		route: '/menu',
		routeName: 'menu',
		icon: 'nav-menu'
	},
	// {
	//     name: '版本管理',
	//     route: '/version',
	//     routeName: 'version',
	//     icon: 'version',
	// },
	{
		name: '功能包',
		route: '/packages',
		routeName: 'packages',
		icon: 'nav-version'
	},
	{
		name: '内置角色',
		route: '/role',
		routeName: 'role',
		icon: 'nav-role'
	},
	{
		name: 'bugs数据统计',
		route: '/statistics',
		routeName: 'statistics',
		icon: 'nav-menu'
	},
	{
		name: '小商店管理',
		route: '/shopManage',
		routeName: 'shopManage',
		icon: 'nav-business'
	}
]
export { navLinks }
